import { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { toast } from '../components/ui/sonner';
import { Logo } from '../components/Logo';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { FORGOT_PASSWORD } from '../constants/testIds';
import { getErrorMessage } from '../lib/errors';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await axios.post(`${API}/client/request-password-reset`, {
        email,
        frontend_base_url: window.location.origin,
      });
      setSent(true);
    } catch (err) {
      toast.error(getErrorMessage(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-brand-bg text-brand-text flex items-center justify-center px-5">
      <div className="text-center max-w-sm w-full">
        <div className="flex justify-center mb-8">
          <Logo />
        </div>
        <h1 className="font-display font-extrabold uppercase text-2xl text-brand-text">Forgot Password</h1>
        <p className="mt-2 text-brand-muted text-sm">
          Enter your email and we&apos;ll send you a link to reset your password.
        </p>

        {sent ? (
          <p data-testid={FORGOT_PASSWORD.successMessage} className="mt-8 text-brand-amber text-sm">
            If an account exists for <strong className="text-brand-text">{email}</strong>, a reset link is on its
            way. Check your inbox (and spam folder) in the next few minutes.
          </p>
        ) : (
          <form onSubmit={handleSubmit} className="mt-8 space-y-4 text-left">
            <div>
              <Label className="text-brand-muted text-xs uppercase tracking-wider">Email</Label>
              <Input
                type="email"
                required
                data-testid={FORGOT_PASSWORD.emailInput}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-1.5 bg-brand-surface2 border-brand-border text-brand-text"
              />
            </div>
            <button
              type="submit"
              disabled={submitting}
              data-testid={FORGOT_PASSWORD.submitButton}
              className="w-full inline-flex items-center justify-center gap-2 bg-brand-orange hover:bg-brand-orangeHover text-white font-display font-bold uppercase tracking-wide rounded-full px-7 py-3 transition-colors disabled:opacity-60"
            >
              {submitting ? 'Sending…' : 'Send Reset Link'}
            </button>
          </form>
        )}

        <p className="mt-6 text-brand-muted text-xs">
          <Link data-testid={FORGOT_PASSWORD.backToLoginLink} to="/login" className="text-brand-amber underline">
            Back to Login
          </Link>
        </p>
      </div>
    </div>
  );
}
